import { useGetAllTags } from '#api/tags';
import ItemList from './ItemList';

interface TagListProps {
  selectedTags: string[];
  onClick: (tag: string) => void;
}

const TagList = ({ selectedTags, onClick }: TagListProps) => {
  const { data: tagsData } = useGetAllTags();

  if (!tagsData) return null;

  return (
    <ItemList
      selectedTags={selectedTags}
      onClick={onClick}
      itemList={tagsData.data}
    />
  );
};

export default TagList;
